<template>
  <div>
    <PageHeader :schema="$schemas.stock" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.stock" :service="$api.stocks" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateStock',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
